(function (w, r) {
  w._rwq = r;

  w[r] = w[r] || function () {
    (w[r].q = w[r].q || []).push(arguments);
  };
})(window, 'rewardful');

var script = document.createElement('script');
script.async = true;
script.src = 'https://r.wdfl.co/rw.js';
script.setAttribute('data-rewardful', process.env.REWARDFUL_API_KEY);
document.head.appendChild(script);